export const DEFAULT_MINUTES_STEP = 1;

export const DEFAULT_TIME_STEPS = {
    hours: 1,
    minutes: DEFAULT_MINUTES_STEP,
    seconds: 5,
};

export function resolveTimeSteps(minutesStep = DEFAULT_MINUTES_STEP, timeSteps) {
    if (timeSteps) {
        return timeSteps;
    }

    return {
        ...DEFAULT_TIME_STEPS,
        minutes: minutesStep,
    };
}
